"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rendall API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverageScoreDetailsScoreToJSON = exports.CoverageScoreDetailsScoreFromJSONTyped = exports.CoverageScoreDetailsScoreFromJSON = exports.instanceOfCoverageScoreDetailsScore = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CoverageScoreDetailsScore interface.
 */
function instanceOfCoverageScoreDetailsScore(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "customer" in value;
    isInstance = isInstance && "coverageScore" in value;
    isInstance = isInstance && "configurationScore" in value;
    isInstance = isInstance && "monitoringScore" in value;
    isInstance = isInstance && "ticketingScore" in value;
    isInstance = isInstance && "exscanScore" in value;
    isInstance = isInstance && "timestamp" in value;
    isInstance = isInstance && "numInternalNmapScannedInPastWeek" in value;
    isInstance = isInstance && "numScanTypesConfigured" in value;
    isInstance = isInstance && "hasRecentSnmpObservations" in value;
    isInstance = isInstance && "adNxlogParserExists" in value;
    isInstance = isInstance && "fwLogParserExists" in value;
    isInstance = isInstance && "customerInGeoApprovedOrRestrictedList" in value;
    isInstance = isInstance && "adPollerLogsExist" in value;
    isInstance = isInstance && "obsExistForConfiguredCloudApps" in value;
    isInstance = isInstance && "numCloudAppsConfigured" in value;
    isInstance = isInstance && "cloudAppsConfigured" in value;
    isInstance = isInstance && "numCloudAppsDetected" in value;
    isInstance = isInstance && "cloudAppsDetected" in value;
    isInstance = isInstance && "serverAvFound" in value;
    isInstance = isInstance && "desktopAvFound" in value;
    isInstance = isInstance && "numEscalationsConfigured" in value;
    isInstance = isInstance && "numCriticalVulnerabilities" in value;
    isInstance = isInstance && "numHighVulnerabilities" in value;
    isInstance = isInstance && "numberOfEmployees" in value;
    isInstance = isInstance && "industry" in value;
    return isInstance;
}
exports.instanceOfCoverageScoreDetailsScore = instanceOfCoverageScoreDetailsScore;
function CoverageScoreDetailsScoreFromJSON(json) {
    return CoverageScoreDetailsScoreFromJSONTyped(json, false);
}
exports.CoverageScoreDetailsScoreFromJSON = CoverageScoreDetailsScoreFromJSON;
function CoverageScoreDetailsScoreFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'customer': json['customer'],
        'coverageScore': json['coverageScore'],
        'configurationScore': json['configurationScore'],
        'monitoringScore': json['monitoringScore'],
        'incidentsScore': !(0, runtime_1.exists)(json, 'incidentsScore') ? undefined : json['incidentsScore'],
        'ticketingScore': json['ticketingScore'],
        'exscanScore': json['exscanScore'],
        'timestamp': (new Date(json['timestamp'])),
        'numInternalNmapScannedInPastWeek': json['numInternalNmapScannedInPastWeek'],
        'numScanTypesConfigured': json['numScanTypesConfigured'],
        'hasRecentSnmpObservations': json['hasRecentSnmpObservations'],
        'adNxlogParserExists': json['adNxlogParserExists'],
        'fwLogParserExists': json['fwLogParserExists'],
        'customerInGeoApprovedOrRestrictedList': json['customerInGeoApprovedOrRestrictedList'],
        'adPollerLogsExist': json['adPollerLogsExist'],
        'obsExistForConfiguredCloudApps': json['obsExistForConfiguredCloudApps'],
        'numCloudAppsConfigured': json['numCloudAppsConfigured'],
        'cloudAppsConfigured': json['cloudAppsConfigured'],
        'numCloudAppsDetected': json['numCloudAppsDetected'],
        'cloudAppsDetected': json['cloudAppsDetected'],
        'serverAvFound': json['serverAvFound'],
        'desktopAvFound': json['desktopAvFound'],
        'numMonthlyIncidents': !(0, runtime_1.exists)(json, 'numMonthlyIncidents') ? undefined : json['numMonthlyIncidents'],
        'numEscalationsConfigured': json['numEscalationsConfigured'],
        'numCriticalVulnerabilities': json['numCriticalVulnerabilities'],
        'numHighVulnerabilities': json['numHighVulnerabilities'],
        'numberOfEmployees': json['numberOfEmployees'],
        'industry': json['industry'],
    };
}
exports.CoverageScoreDetailsScoreFromJSONTyped = CoverageScoreDetailsScoreFromJSONTyped;
function CoverageScoreDetailsScoreToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'customer': value.customer,
        'coverageScore': value.coverageScore,
        'configurationScore': value.configurationScore,
        'monitoringScore': value.monitoringScore,
        'incidentsScore': value.incidentsScore,
        'ticketingScore': value.ticketingScore,
        'exscanScore': value.exscanScore,
        'timestamp': (value.timestamp.toISOString()),
        'numInternalNmapScannedInPastWeek': value.numInternalNmapScannedInPastWeek,
        'numScanTypesConfigured': value.numScanTypesConfigured,
        'hasRecentSnmpObservations': value.hasRecentSnmpObservations,
        'adNxlogParserExists': value.adNxlogParserExists,
        'fwLogParserExists': value.fwLogParserExists,
        'customerInGeoApprovedOrRestrictedList': value.customerInGeoApprovedOrRestrictedList,
        'adPollerLogsExist': value.adPollerLogsExist,
        'obsExistForConfiguredCloudApps': value.obsExistForConfiguredCloudApps,
        'numCloudAppsConfigured': value.numCloudAppsConfigured,
        'cloudAppsConfigured': value.cloudAppsConfigured,
        'numCloudAppsDetected': value.numCloudAppsDetected,
        'cloudAppsDetected': value.cloudAppsDetected,
        'serverAvFound': value.serverAvFound,
        'desktopAvFound': value.desktopAvFound,
        'numMonthlyIncidents': value.numMonthlyIncidents,
        'numEscalationsConfigured': value.numEscalationsConfigured,
        'numCriticalVulnerabilities': value.numCriticalVulnerabilities,
        'numHighVulnerabilities': value.numHighVulnerabilities,
        'numberOfEmployees': value.numberOfEmployees,
        'industry': value.industry,
    };
}
exports.CoverageScoreDetailsScoreToJSON = CoverageScoreDetailsScoreToJSON;
